"use strict";

define('app/print/abstract/print.abstract.view',['rs/abstract.content.view'], function (AbstractContentView) {
  var PrintLetterView = AbstractContentView.extend({
    hideHeader: function hideHeader() {
      this.$el.parent().find('#header').hide();
    },
    showHeader: function showHeader() {
      this.$el.parent().find('#header').show();
    },
    refreshContentSizing: function refreshContentSizing() {},
    unload: function unload() {
      this.showHeader();
    }
  });
  return PrintLetterView;
});

